import React, { useState } from "react"
import PropTypes from "prop-types"
import Slider from "react-slick"
import { useTheme } from "@mui/material/styles"
import Card from "@mui/material/Card"
import Box from "@mui/material/Box"
import CardContent from "@mui/material/CardContent"
import Typography from "@mui/material/Typography"
import Grid from "@mui/material/Grid"
import ListItem from "@mui/material/ListItem"
import ListItemText from "@mui/material/ListItemText"
import Button from "@mui/material/Button"

const Reviews = () => {
    const theme = useTheme()

    const GridItemReviewBlock = () => {
        const sliderOpts = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
        }

        const reviews = [
            {
                feedback:
                    "Kaden is an outstanding professional. Every transaction has been seamless. He is very knowledgeable and puts the clients' interests first always. Highly recommended!",
                name: "Dave Holland",
            },
            {
                feedback:
                    "Kaden is a joy to work with! His honesty, care, and energy made the buying process easy for my husband and I. I 100% recommend him if you are looking for a realtor!",
                name: "Allison Hostetter",
            },
            {
                feedback:
                    "I had the opportunity to work with Kaden, and I highly recommend his services. He navigated a difficult transaction successfully with grace and dignity.",
                name: "Helen Hawes",
            },
            {
                feedback:
                    "Kaden is absolutely wonderful! I was preparing to move from Michigan to San Diego. Not only did Kaden help me search for properties, but also did site visits with video! He was always patient, kind, and accommodating!",
                name: "Premium Heart",
            },
            {
                feedback:
                    "It is my pleasure to write this review for Kaden. I was apprehensive about the whole process, but I was pleasantly surprised by how easy he made it.",
                name: "Maureen Lyons",
            },
            {
                feedback:
                    "We have worked with many real estate agents over the years, and we've never worked with an agent as knowledgeable and professional as Kaden.",
                name: "Cynthia Fong",
            },
            {
                feedback:
                    "Working with Kaden was an unparalleled experience. He demonstrated a deep understanding of the market and genuine dedication.",
                name: "Dylan",
            },
            {
                feedback:
                    "Kaden is a great asset in the home buying process. He exudes charisma and has the technical prowess to find the perfect listing.",
                name: "Logan Pardini",
            },
            {
                feedback:
                    "I had a great experience working with Kaden Cowles. He was very informative throughout our home-buying process and helped us with escrow as well.",
                name: "Taryn Davis",
            },
            {
                feedback:
                    "Kaden found us the perfect apartment in no time when moving to San Diego. He made the process a breeze.",
                name: "Joe Delamere",
            },
            {
                feedback:
                    "Kaden is a great person who always brings good vibes and good intentions. I highly recommend him to anyone looking to buy a home.",
                name: "Thomas Lanphear",
            },
            {
                feedback:
                    "Incredibly great service. Conveniently located, with privacy and well-equipped surroundings.",
                name: "Jim Gale",
            },
            // Add additional reviews here
        ]

        return (
            <Box maxWidth={"100%"}>
                <Slider {...sliderOpts}>
                    {reviews.map((item, i) => (
                        <ReviewCard key={i} review={item} theme={theme} />
                    ))}
                </Slider>
            </Box>
        )
    }

    const ReviewCard = ({ review, theme }) => {
        const [showFullText, setShowFullText] = useState(false)

        const toggleShowMore = () => {
            setShowFullText(!showFullText)
        }

        return (
            <Box padding={{ xs: 1, sm: 2, lg: 3 }}>
                <Box
                    component={Card}
                    boxShadow={{ xs: 1, sm: 3 }}
                    borderRadius={5}
                    padding={{ xs: 1, sm: 2, md: 3 }}
                >
                    <CardContent>
                        <Box marginBottom={1}>
                            {[1, 2, 3, 4, 5].map((star) => (
                                <Box
                                    key={star}
                                    color={theme.palette.secondary.main}
                                    display={"inline"}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                        width={24}
                                        height={24}
                                    >
                                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                                    </svg>
                                </Box>
                            ))}
                        </Box>
                        <Box
                            component={Typography}
                            variant={"h6"}
                            fontWeight={400}
                            marginBottom={2}
                            sx={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "-webkit-box",
                                WebkitLineClamp: showFullText ? "unset" : 2,
                                WebkitBoxOrient: "vertical",
                            }}
                        >
                            {review.feedback}
                        </Box>
                        {!showFullText && (
                            <Button
                                onClick={toggleShowMore}
                                sx={{
                                    color: "blue",
                                    fontWeight: "bold",
                                    textTransform: "none",
                                    fontSize: "0.75rem",
                                    padding: 0,
                                }}
                            >
                                See more
                            </Button>
                        )}
                        {showFullText && (
                            <Button
                                onClick={toggleShowMore}
                                sx={{
                                    color: "blue",
                                    fontWeight: "bold",
                                    textTransform: "none",
                                    fontSize: "0.875rem",
                                    padding: 0,
                                }}
                            >
                                See less
                            </Button>
                        )}
                        <Box width={1} marginTop={2}>
                            <ListItem disableGutters width={"auto"} padding={0}>
                                <ListItemText
                                    primary={review.name}
                                    primaryTypographyProps={{
                                        fontWeight: "bold",
                                        fontSize: "1.25rem",
                                    }}
                                />
                            </ListItem>
                        </Box>
                    </CardContent>
                </Box>
            </Box>
        )
    }

    ReviewCard.propTypes = {
        review: PropTypes.shape({
            feedback: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
        }).isRequired,
        theme: PropTypes.object.isRequired,
    }

    return (
        <Box>
            <Grid container spacing={4}>
                <Grid item xs={12} md={6}>
                    <Box
                        width={1}
                        height="100%"
                        display="flex"
                        alignItems="center"
                    >
                        <Typography
                            variant="h3"
                            fontWeight="bold"
                            color="textPrimary"
                        >
                            Don&apos;t just take our word for it
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Box
                        width={1}
                        height="100%"
                        display="flex"
                        alignItems="center"
                    >
                        <GridItemReviewBlock />
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
}

export default Reviews
